export default __webpack_public_path__ + "static/photo-nathalie-vigneron-larosa-7f2a7c01d20d164deb024315276c5d7d.webp";